import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { type ReactElement } from 'react'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'

interface TableHeaderProps {
  title: string
  width: number
}

export function RpOccurrencesTableHeader ({ title, width }: TableHeaderProps): ReactElement {
  const { siteTheme: { tableHeaderColors } } = useSnapshot(proxyGlobalAuth)

  return (
    <th
      className={cn(tableHeaderColors.backgroundClasses, 'py-2 px-4 cursor-pointer')}
      style={{ width: `${width}%` }}
    >
      <div className="flex">
        <div className={tableHeaderColors.secondaryFontClasses}>{title}</div>
      </div>
    </th>
  )
}
